import { zh } from './locales/zh'

export type Locale = 'zh' | 'en' | 'th'

export const SUPPORTED_LOCALES: Locale[] = ['zh', 'en', 'th']

export const DEFAULT_LOCALE: Locale = 'zh'

/**
 * 将语言包中的字符串字面量递归放宽为 string，
 * 使 en/th 与 zh 结构一致但文案值可为任意语言。
 */
export type DeepString<T> = T extends string
  ? string
  : T extends readonly (infer U)[]
  ? DeepString<U>[]
  : T extends object
  ? { [K in keyof T]: DeepString<T[K]> }
  : T

export type MessageSchema = DeepString<typeof zh>

export type Messages = MessageSchema


export type MessageKey =
  | `common.${string}`
  | `board.${string}`
  | `localRedraw.${string}`
  | `swatches.${string}`
  | `boardNew.${string}`
